<template>
  <div id="new-transhipment">
    <BreadCrumb :items="breadcrumbItems" />

    <v-row>
      <v-col cols="12">
        <v-card v-if="loading && parameterID" elevation="2" class="py-5 px-5 mt-1 text-center">
          Aguarde, buscando dados
          <div class="mt20"></div>
          <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
        </v-card>
        <v-card v-else elevation="2" class="py-5 mt-1">
          <v-tabs>
            <v-tab class="mx-5 px-5">{{ namePage }}</v-tab>
            <v-tab class="px-5" v-if="viewDeliveryForm"> {{ deliveryTabName }} </v-tab>

            <v-tab-item>
              <div class="mt-5">
                <v-form @submit.prevent="submit">
                  <v-row v-if="!onlyView" class="px-9">
                    <v-col cols="12" md="4">
                      <v-select
                        :disabled="onlyView"
                        v-model="typeTranshipmentSelected"
                        :items="typeTranshipment"
                        :rules="rules"
                        label="Tipo do Transbordo"
                      ></v-select>
                    </v-col>
                    <v-col class="d-flex" cols="12" md="6">
                      <v-checkbox
                        v-model="isDeliverierTranshipment"
                        label="Transbordo Entregador"
                        hide-details
                        class="mt-7"
                        @change="updateBankData"
                      >
                        <template v-slot:append>
                          <v-tooltip right nudge-top="1">
                            <template #activator="{ attrs, on }">
                              <v-icon v-bind="attrs" v-on="on" size="24">mdi-information-outline </v-icon>
                            </template>
                            <span>Além de ser responsável pelo transbordo, também realiza a entregas</span>
                          </v-tooltip>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <div class="divider mt-3 mb-5"></div>
                    </v-col>
                  </v-row>

                  <v-row class="px-9">
                    <v-col cols="12">
                      <h6>Dados Gerais</h6>
                    </v-col>

                    <v-col cols="12" :md="isPersonal ? '8' : '4'">
                      <v-text-field
                        v-model="generalData.name"
                        :label="isPersonal ? 'Nome (Obrigatório)' : 'Razão Social (Obrigatório)'"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" v-if="!isPersonal">
                      <v-text-field
                        v-model="generalData.tradingName"
                        label="Nome Fantasia (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" v-show="isPersonal">
                      <v-text-field
                        v-model="generalData.cpf"
                        label="CPF (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        v-mask="'###.###.###-##'"
                        @change="updateBankData"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" v-show="!isPersonal">
                      <v-text-field
                        v-model="generalData.cnpj"
                        label="CNPJ (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        v-mask="'##.###.###/####-##'"
                        @change="updateBankData"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="generalData.phone"
                        label="Telefone (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        autocomplete="off"
                        v-mask="'(##) ####-####'"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="generalData.cellphone"
                        label="Celular (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        autocomplete="off"
                        v-mask="'(##) # ####-####'"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="generalData.email"
                        label="Email"
                        type="email"
                        :disabled="onlyView"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>
                    <v-col v-if="onlyView" cols="12" md="3">
                      <v-select
                        :disabled="onlyView"
                        v-model="typeTranshipmentSelected"
                        :items="typeTranshipment"
                        :rules="rules"
                        label="Tipo do Transbordo"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <div class="divider mt-3 mb-5"></div>
                    </v-col>
                  </v-row>

                  <v-row class="px-9">
                    <v-col cols="12">
                      <h6>Endereço</h6>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="addressData.cep"
                        label="CEP (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        autocomplete="off"
                        v-mask="'#####-###'"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        v-model="addressData.state"
                        label="Estado (Obrigatório)"
                        :items="getStates"
                        :rules="rules"
                        item-text="name"
                        item-value="id"
                        :disabled="onlyView"
                        @change="fetchCitiesByID"
                      >
                      </v-select>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        v-model="addressData.cityId"
                        label="Cidade (Obrigatório)"
                        :items="getCities"
                        :rules="rules"
                        item-text="name"
                        item-value="id"
                        :disabled="disableCity"
                        :loading="loadingCity"
                      >
                      </v-select>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="addressData.neighborhood"
                        label="Bairro (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="addressData.street"
                        label="Logradouro (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="addressData.number"
                        label="Número (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="addressData.complement"
                        label="Complemento"
                        :disabled="onlyView"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <div class="divider mt-3 mb-5"></div>
                    </v-col>
                  </v-row>

                  <v-row class="px-9">
                    <v-col cols="12">
                      <h6>Dados Bancários</h6>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="bankData.bankName"
                        label="Banco (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="bankData.agency"
                        label="Agência (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        autocomplete="off"
                        v-mask="'#####'"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="bankData.account"
                        label="Conta (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="onlyView"
                        autocomplete="off"
                        v-mask="'##########'"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="bankData.cpfOrCnpjHolder"
                        :label="
                          !this.bankData.isHolder
                            ? 'CPF/CNPJ do titular da conta (Obrigatório)'
                            : 'CPF/CNPJ do titular da conta'
                        "
                        :rules="!bankData.isHolder ? rules : []"
                        required
                        :disabled="onlyView"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="bankData.pixKey"
                        label="PIX"
                        required
                        :disabled="onlyView"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <p class="label-radio-group">Títular da conta (Obrigatório)</p>
                      <v-radio-group v-model="bankData.isHolder" row :disabled="onlyView" @change="updateBankData">
                        <v-radio label="Sim" :value="true"></v-radio>
                        <v-radio label="Não" :value="false"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <div class="divider mt-3 mb-5"></div>
                    </v-col>
                  </v-row>

                  <v-row class="px-9">
                    <v-col cols="12">
                      <h6>Dados de Acesso</h6>
                    </v-col>
                    <v-col cols="12" md v-show="isPersonal">
                      <v-text-field
                        v-model="generalData.cpf"
                        label="CPF (Obrigatório)"
                        disabled
                        readonly
                        v-mask="'###.###.###-##'"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md v-show="!isPersonal">
                      <v-text-field
                        v-model="generalData.cnpj"
                        label="CNPJ (Obrigatório)"
                        disabled
                        readonly
                        v-mask="'##.###.###/####-##'"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md>
                      <v-text-field
                        v-model="accessData.password"
                        :label="!parameterID ? 'Senha (Obrigatório)' : 'Senha'"
                        type="password"
                        required
                        :disabled="onlyView"
                        :rules="!parameterID ? rules : []"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md>
                      <v-text-field
                        v-model="accessData.confirmPassword"
                        :label="!parameterID ? 'Confirmar Senha (Obrigatório)' : ' Confirmar Senha'"
                        type="password"
                        required
                        :disabled="onlyView"
                        :rules="!parameterID ? rules : []"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-if="onlyView">
                    <v-col cols="12">
                      <div class="divider mt-3 mb-5"></div>
                    </v-col>
                  </v-row>

                  <v-row class="px-12" v-if="onlyView">
                    <transhipment-unfinished-stops />
                  </v-row>

                  <v-row class="px-9">
                    <v-col cols="12" class="d-flex justify-end">
                      <v-btn
                        large
                        :color="onlyView ? 'info' : 'error'"
                        :class="onlyView ? '' : 'mr-5'"
                        @click="cancel()"
                      >
                        {{ onlyView ? 'VOLTAR' : 'CANCELAR' }}
                      </v-btn>
                      <v-btn
                        v-if="!onlyView"
                        large
                        color="success"
                        @click="submit()"
                        :loading="loadingToCreate"
                        :disabled="!checkForm()"
                      >
                        SALVAR
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
            </v-tab-item>
            <v-tab-item v-if="viewDeliveryForm">
              <div class="mt-5">
                <v-form @submit.prevent="submit">
                  <v-row class="px-9">
                    <v-col cols="12">
                      <h6>Dados Gerais</h6>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field v-model="generalData.name" :label="'Nome'" disabled></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="cpfDeliverierTranshipment"
                        label="CPF (Obrigatório)"
                        required
                        :rules="rules"
                        :disabled="isPersonal"
                        v-mask="'###.###.###-##'"
                        @change="updateBankData"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="cnhNumber"
                        label="CNH (Obrigatório)"
                        required
                        :rules="rules"
                        v-mask="'#########-##'"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <div class="divider mt-3 mb-5"></div>
                    </v-col>
                  </v-row>

                  <v-row class="px-9">
                    <v-col cols="12">
                      <h6>Dados do Veículo</h6>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-select
                        v-model="vehicleData.typeVehicleId"
                        label="Tipo de Veículo (Obrigatório)"
                        :rules="rules"
                        :items="getVehiclesTypes"
                        item-text="name"
                        item-value="id"
                        :disabled="onlyView"
                      >
                      </v-select>
                    </v-col>

                    <v-col cols="12" md="4" v-if="vehicleData.typeVehicleId === '4a9cebb6-142a-4d9b-a79b-606c5e1250ae'">
                      <v-text-field
                        v-model="vehicleData.description"
                        label="Descrição"
                        required
                        :disabled="onlyView"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="vehicleData.renavam"
                        label="RENAVAM (Obrigatório)"
                        :rules="rules"
                        required
                        v-mask="'###########'"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="vehicleData.plate"
                        label="Placa (Obrigatório)"
                        :rules="rules"
                        required
                        v-mask="'NNNNNNN'"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-if="onlyView">
                    <v-col cols="12">
                      <div class="divider mt-3 mb-5"></div>
                    </v-col>
                  </v-row>

                  <v-row class="px-9">
                    <v-col cols="12" class="d-flex justify-end">
                      <v-btn
                        large
                        :color="onlyView ? 'info' : 'error'"
                        :class="onlyView ? '' : 'mr-5'"
                        @click="cancel()"
                      >
                        {{ onlyView ? 'VOLTAR' : 'CANCELAR' }}
                      </v-btn>
                      <v-btn
                        v-if="!onlyView"
                        large
                        color="success"
                        @click="submit()"
                        :loading="loadingToCreate"
                        :disabled="!checkForm()"
                      >
                        SALVAR
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>

    <MessagesError :type="errorsType" :errors="errors" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BreadCrumb from '@/components/BreadCrumb.vue';
import MessagesError from '@/components/MessagesError.vue';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';

export default {
  name: 'NewTranshipment',
  components: {
    BreadCrumb,
    MessagesError
  },
  data: () => ({
    loadingToCreate: false,
    errors: [],
    errorsType: null,
    typeTranshipment: [
      {
        text: 'Empresa',
        value: 'enterprise'
      },
      {
        text: 'Pessoal',
        value: 'personal'
      }
    ],
    isDeliverierTranshipment: false,
    hasCnhNumber: null,
    typeTranshipmentSelected: 'enterprise',
    isValidPassword: false,
    loadingCity: false,
    isValidDocument: false,
    loading: true,
    maskCpfOrCnpj: null,
    generalData: {
      name: null,
      tradingName: null,
      cpf: null,
      cnpj: null,
      phone: null,
      email: null,
      cellphone: null
    },
    addressData: {
      cep: null,
      neighborhood: null,
      street: null,
      state: null,
      cityId: null,
      number: null,
      complement: null
    },
    bankData: {
      bankName: null,
      agency: null,
      account: null,
      cpfOrCnpjHolder: null,
      pixKey: null,
      isHolder: true
    },
    accessData: {
      password: null,
      confirmPassword: null
    },
    vehicleData: {
      typeVehicleId: null,
      renavam: null,
      plate: null,
      description: null
    },
    cnhNumber: null,
    cpfDeliverierTranshipment: null,
    rules: [(value) => !!value || 'Required.']
  }),
  computed: {
    ...mapGetters('AdressStore', ['getStates', 'getCities']),
    ...mapGetters('CouriersStore', ['getVehiclesTypes']),
    breadcrumbItems() {
      return [
        {
          text: 'Início',
          disabled: false,
          to: '/start'
        },
        {
          text: 'Transbordos',
          disabled: false,
          to: '/transhipments',
          exact: true
        },
        {
          text: this.namePage,
          disabled: true
        }
      ];
    },
    disableCity() {
      if (this.onlyView) {
        return true;
      }

      return !this.addressData.state;
    },
    onlyView() {
      return this.$route.name === 'ViewTranshipment';
    },
    namePage() {
      if (this.parameterID) {
        if (this.onlyView) {
          return 'Visualizar transbordo';
        } else {
          return 'Editar transbordo';
        }
      }

      return 'Novo transbordo';
    },
    deliveryTabName() {
      if (this.parameterID && this.hasCnhNumber) {
        return 'Editar entregador';
      } else {
        return 'Novo entregador';
      }
    },
    isPersonal() {
      return this.typeTranshipmentSelected === 'personal';
    },
    parameterID() {
      return this.$route.params.id;
    },
    isCompanyInRoute() {
      return Boolean(Number(this.$route.params.type));
    },

    viewDeliveryForm() {
      return this.isDeliverierTranshipment;
    }
  },
  mounted() {
    this.fetchAllStates();
    this.fetchAllVehiclesTypes();

    if (this.parameterID) {
      this.transhipmentEdit();
    }
  },
  methods: {
    ...mapActions('TranshipmentStore', ['createTranshipment', 'editTranshipment', 'fetchTranshipmentByID']),
    ...mapActions('AdressStore', ['fetchStates', 'fetchCities']),
    ...mapActions('CouriersStore', ['fetchVehiclesTypes']),

    setValidDocument(bool = true) {
      this.isValidDocument = bool;

      if (bool === true) {
        setTimeout(() => {
          this.isValidDocument = false;
        }, 3000);
      }
    },
    updateBankData() {
      if (this.isPersonal && this.isDeliverierTranshipment) {
        this.cpfDeliverierTranshipment = this.generalData.cpf;
      }

      if (this.bankData.isHolder) {
        if (this.isPersonal) {
          this.bankData.cpfOrCnpjHolder = this.generalData.cpf;
        } else {
          this.bankData.cpfOrCnpjHolder = this.generalData.cnpj;
        }
      } else {
        this.bankData.cpfOrCnpjHolder = '';
      }
    },
    checkForm() {
      const requiredFields = [
        this.generalData.name,
        this.generalData.phone,
        this.generalData.cellphone,
        this.addressData.cep,
        this.addressData.neighborhood,
        this.addressData.street,
        this.addressData.state,
        this.addressData.cityId,
        this.addressData.number,
        this.bankData.bankName,
        this.bankData.agency,
        this.bankData.account
      ];
      if (this.typeTranshipmentSelected === 'enterprise') {
        requiredFields.push(this.generalData.tradingName, this.generalData.cnpj);
      } else {
        requiredFields.push(this.generalData.cpf);
      }
      if (!this.parameterID) {
        requiredFields.push(this.accessData.password);
        requiredFields.push(this.accessData.confirmPassword);
      }
      if (!this.bankData.isHolder) {
        requiredFields.push(this.bankData.cpfOrCnpjHolder);
      }
      if (this.isDeliverierTranshipment) {
        requiredFields.push(this.vehicleData.typeVehicleId, this.vehicleData.renavam, this.vehicleData.plate);
      }
      return requiredFields.every((field) => field !== null && field !== '');
    },
    async submit() {
      if (!this.checkForm()) {
        this.errors = ['Campos inválidos! Verifique se você não esqueceu algum campo obrigatório.'];
        this.errorsType = 'info';
        return;
      } else if (
        (this.accessData.password !== null && this.accessData.password !== '') ||
        (this.accessData.confirmPassword !== null && this.accessData.confirmPassword !== '')
      ) {
        if (this.accessData.password !== this.accessData.confirmPassword) {
          this.errors = ['As senhas não conferem.'];
          this.errorsType = 'info';
          return;
        }
      }

      this.loadingToCreate = true;
      let body = {
        type: this.typeTranshipmentSelected,
        params: {
          ...this.generalData,
          ...this.accessData,
          addressData: this.addressData,
          bankData: this.bankData,
          vehicleData: this.vehicleData,
          cnhNumber: this.cnhNumber,
          cpfDeliverierTranshipment: this.cpfDeliverierTranshipment,
          isDeliverierTranshipment: this.isDeliverierTranshipment
        }
      };
      if (this.parameterID) {
        body.params.id = this.parameterID;
      }

      try {
        const status = this.parameterID ? await this.editTranshipment(body) : await this.createTranshipment(body);
        if (status.success) {
          const message = this.parameterID ? 'Transbordo editado com sucesso!' : 'Transbordo cadastrado com sucesso!';
          FeedbackMessageHandler.setFeedbackMessage(this, message);
          this.$router.push('/transhipments');
        } else {
          this.errors = status.errors;
          this.errorsType = 'info';
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingToCreate = false;
      }
    },
    async fetchAllRoles() {
      try {
        await this.fetchRoles();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchAllStates() {
      try {
        await this.fetchStates();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchCitiesByID() {
      this.loadingCity = true;
      try {
        await this.fetchCities(this.addressData.state);
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingCity = false;
      }
    },
    async fetchAllVehiclesTypes() {
      try {
        await this.fetchVehiclesTypes();
      } catch (err) {
        console.error(err);
      }
    },
    cancel() {
      this.$router.back();
    },
    setValidPassword(bool = true) {
      this.isValidPassword = bool;

      if (bool === true) {
        setTimeout(() => {
          this.isValidPassword = false;
        }, 3000);
      }
    },
    async transhipmentEdit() {
      this.loading = true;
      try {
        const data = await this.fetchTranshipmentByID({
          id: this.parameterID,
          type: this.isCompanyInRoute
        });
        this.typeTranshipmentSelected = this.isCompanyInRoute ? 'enterprise' : 'personal';

        this.generalData.name = this.isCompanyInRoute ? data.companyName : data.name;

        if (this.isCompanyInRoute) {
          this.generalData.tradingName = data.tradingName;
        }
        this.isDeliverierTranshipment = data.isDeliverierTranshipment;

        this.generalData.cnpj = data.cnpj || null;
        this.generalData.cpf = data.cpf || null;

        this.generalData.phone = data.phones[0];
        this.generalData.cellphone = data.phones[1];
        this.generalData.email = data.email;

        this.addressData.cep = data.address.cep;
        this.addressData.neighborhood = data.address.neighborhood;
        this.addressData.street = data.address.street;
        this.addressData.cityId = data.address.cityId;
        this.addressData.state = data.address.stateId;

        this.loadingCity = true;
        try {
          await this.fetchCities(data.address.stateId);
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingCity = false;
        }

        this.addressData.number = data.address.number;
        this.addressData.complement = data.address.complement;

        this.bankData.bankName = data.bankData.bankName;
        this.bankData.agency = data.bankData.agency;
        this.bankData.account = data.bankData.account;
        this.bankData.cpfOrCnpjHolder = data.bankData.cpfOrCnpjHolder;
        this.bankData.pixKey = data.bankData.pixKey;
        this.bankData.isHolder = data.bankData.isHolder;

        if (data.vehicle) {
          this.cnhNumber = data.cnhNumber;
          this.hasCnhNumber = data.cnhNumber;
          this.cpfDeliverierTranshipment = data.cpfDeliverierTranshipment;
          this.vehicleData.description = data.vehicle.description;
          this.vehicleData.plate = data.vehicle.plate;
          this.vehicleData.renavam = data.vehicle.renavam;
          this.vehicleData.typeVehicleId = data.vehicle.typeVehicleId;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
#new-transhipment {
}
</style>
